<template>
  <el-dialog
    class="modal-stores-list"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
    lock-scroll
    append-to-body
  >
    <div class="content">
      <div class="transfer-wrapper" @submit.prevent>
        <!-- 左侧 -->
        <div class="transfer__left">
          <div class="transfer-header__wrapper">
            <div class="filter-wrapper">
              <el-input v-model="filter.storeName" placeholder="门店名称" class="filter-keyword__input"></el-input>
              <el-input v-model="filter.storeId" placeholder="门店ID" class="filter-keyword__input"></el-input>
              <el-input v-model="filter.shopId" placeholder="中台门店ID" class="filter-keyword__input"></el-input>
              <el-select style="width:110px;" v-model="filter.provinces" filterable placeholder="省份">
                <el-option value="">省份</el-option>
                <el-option
                  v-for="item in provinces"
                  :key="item.id"
                  :label="item.regionName"
                  :value="item.regionCode">
                </el-option>
              </el-select>

              <el-select style="width:110px;" v-model="filter.citys" filterable placeholder="城市">
                <el-option value="">城市</el-option>
                <el-option
                  v-for="item in citys"
                  :key="item.id"
                  :label="item.regionName"
                  :value="item.regionCode">
                </el-option>
              </el-select>

              <el-select style="width:110px;" v-model="filter.districts" filterable placeholder="区域">
                <el-option value="">区域</el-option>
                <el-option
                  v-for="item in districts"
                  :key="item.id"
                  :label="item.regionName"
                  :value="item.regionCode">
                </el-option>
              </el-select>
              <el-button @click="$_search" class="search__btn">查询</el-button>
              <el-button @click="$_reset" class="reset__btn">重置</el-button>
            </div>
          </div>

          <!-- 数据列表 -->
          <el-table
            class="table-list__box"
            ref="standbyList"
            :data="dataList"
            v-loading="isLoading"
            :height="534"
            stripe
            tooltip-effect="dark"
          >
            <el-table-column
              v-for="column in columns"
              :key="column.key"
              :prop="column.key"
              :label="column.label"
              :width="column.width"
              :resizable="false"
              sortable
              show-overflow-tooltip
            ></el-table-column>

            <div class="table-list__empty small" slot="empty"></div>
          </el-table>

          <div class="pagination__wrapper">
            <cd-pagination
              ref="pager"
              :total="pagination.total"
              :currPage="pagination.pageNow"
              :pageSize="pagination.pageSize"
              @changepage="$_changeCurrent"
              @changesize="$_changeSize"
              :explainShow="false"
              @refresh="$_getStoreList"
            ></cd-pagination>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
const columns = [
  { key: "brandName", label: "品牌名称"},
  { key: "brandId", label: "品牌ID", width: 120},
  { key: "storeName", label: "门店名称", width: 120 },
  { key: "storeId", label: "门店ID", width: 120 },
   { key: "shopId", label: "中台门店ID", width: 120 },
  { key: "provinceName", label: "省份", width: 120 },
  { key: "cityName", label: "城市", width: 120 },
  { key: "areaName", label: "行政区域"}
];

export default {
  name: "stores-list",
  props: {
    title: { type: String, default: "" },
    provinces: { type: Array, default: function () {
      return [];
    }},
    modalData: { type: Object, default: {} },
    platformKey: { type: String, default: "" },
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      filter: {
        storeName: "",
        storeId: "",
        shopId: "",
        provinces: "", // 全部省份
        citys: "", // 全部城市
        districts: "", // 全部行政区域
      },
      citys: [],//城市列表
      districts: [],//地区列表
      columns,
      dataList: [],
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
    };
  },
  watch: {
    'filter.provinces'(val) {
      if(val != ''){
        this.$service.post("getRegionData", {
          level: 'city',
          parentRegionCodeId: -1,
          parentRegionCode: val
        }).then(result => {
          if (result.$.checkResult(result, true)) {
            this.citys = result.data.concat([]);
          }
        });
      }else{
        this.citys = [];
      }
      //重置
      this.filter.citys = '';
      this.filter.districts  = '';
    },
    'filter.citys'(val) {
      if(val != ''){
        this.$service.post("getRegionData", {
          level: 'area',
          parentRegionCodeId: -1,
          parentRegionCode: val
        }).then(result => {
          if (result.$.checkResult(result, true)) {
            this.districts = result.data.concat([]);
          }
        });
      }else{
        this.districts = [];
      }
      //重置
      this.filter.districts  = '';
    },
  },
  methods: {
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      let reg = /[^\d.]/g;
      if(this.filter.shopId && new RegExp(reg).test(this.filter.shopId)){
         $MessageBox.alert({
         content: `
            <div>中台门店id需填数字！</div>
          `,
        });
      }else{
        this.$_getStoreList();
      }
    },
    // 重置
    $_reset() {
      this.filter.storeName = "";
      this.filter.storeId = "";
      this.filter.shopId = "";
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.filter.provinces = "";
      this.filter.citys = "";
      this.filter.districts = "";
      this.$_getStoreList();
    },
    // 查询门店列表
    $_getStoreList() {
      this.isLoading = true;
      const postData = {
        orgId: this.modalData.dataObj.id,
        storeName: this.filter.storeName,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize,
        provinceCode: this.filter.provinces,
        cityCode: this.filter.citys,
        areaCode: this.filter.districts
      };
      if(this.filter.storeId != ''){
        postData.storeId = this.filter.storeId;
      }
      if(this.filter.shopId != ''){
        postData.shopId = Number(this.filter.shopId);
      }
      this.$service.post("getOrgShopDetailList", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getStoreList();
    },
    // 切换每页条数
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getStoreList();
    },
     $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
  },
  created() {
    this.$_getStoreList();
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 10px 20px;
  width: 988px;
}
/deep/ .el-dialog__body{
  height: 642px!important;
}
.el-select{
  margin-right: 10px;
}
.filter-box {
  position: relative;
  height: 60px;
  border: 1px solid #eee;
  background-color: #f5f6f7;
  padding: 0 14px;
  display: flex;
  justify-content: left;
  align-items: center;
  .autocomplete-box {
    display: inline-block;
    position: relative;

    .autocomplete-empty {
      padding: 10px;
      margin: 0;
      color: #535353;
      top: 33px;
      width: 100%;
    }
  }
}
.transfer-wrapper {
  &::after {
    content: "";
    display: table;
    clear: both;
  }
  .transfer__left{
    width: 100%;
    height: 564px;
  }
  .transfer__right {
    float: right;
  }
  .transfer-header__wrapper {
    position: relative;
    height: 49px;
    border-bottom: 1px solid #eee;
    background-color: #f5f6f7;
    padding-left: 8px;
    h3 {
      line-height: 58px;
      font-size: 14px;
      color: #535353;
    }
    .filter-wrapper,
    .clear-all__btn {
      position: absolute;
    }
    .filter-wrapper {
      top: 11px;
    }
    .filter-keyword__input {
      width: 110px;
      margin-right: 10px;
    }
    .clear-all__btn {
      top: 15px;
      right: 20px;
    }
  }
}

.table-list__box {
  border: 1px solid #eee;
  margin-top: -1px;
  background-color: #f9f9f9;
}
</style>


